export const formVacIsRequiredSchema = [
  {
    fieldName: 'displayVacIsRequiredForRelatives',
    type: 'Checkbox',
    label: 'Display VAC in the form',
  },
];
